import { Button, PageTitle } from "@cheatsheetz/core-ui";
import { HomeRoutes } from "@cheatsheetz/sheetz-home/routes";
import { Link } from "react-router-dom";

export function NotFoundPage() {
  return (
    <div className="flex flex-1 items-center justify-center px-4 py-16">
      <PageTitle title="Page Not Found" />
      <div className="flex flex-col items-center gap-4 text-center">
        <h1 className="text-6xl font-bold text-muted-fg">404</h1>
        <p className="text-lg text-muted-fg">Page Not Found</p>
        <p className="max-w-sm text-sm text-muted-fg">
          The page you&apos;re looking for doesn&apos;t exist or has been moved.
        </p>
        <Link to={HomeRoutes.Home}>
          <Button intent="primary" size="small">
            Back to Home
          </Button>
        </Link>
      </div>
    </div>
  );
}
